function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.583 19.419l3.803-1.268a1 1 0 01.767.056A7.382 7.382 0 0012.5 19a7.502 7.502 0 006.708-4.15 7.38 7.38 0 00.793-3.347l.001-.448c-.21-3.807-3.25-6.846-7.001-7.055h-.503a7.385 7.385 0 00-3.35.795 7.5 7.5 0 00-4.147 6.708 7.38 7.38 0 00.792 3.346 1 1 0 01.056.767L4.583 19.42zm17.419-7.92a9.376 9.376 0 01-1.006 4.248A9.5 9.5 0 0112.504 21a9.38 9.38 0 01-3.868-.824L3.318 21.95a1 1 0 01-1.265-1.265l1.773-5.318A9.498 9.498 0 018.25 3.007 9.377 9.377 0 0112.5 2l.556.002c4.826.266 8.678 4.118 8.946 8.998v.499z"
});

var SvgMessage = function SvgMessage(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/message.bfa905c2.svg";
export { SvgMessage as ReactComponent };